/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { invoiceIndex } from '../../axios/invoiceIndex'
import type { InvoiceIndexError, InvoiceIndexPathParams, InvoiceIndexResponse } from '../../types/InvoiceIndex'

export const invoiceIndexQueryKey = (organisation: InvoiceIndexPathParams['organisation']) =>
	[{ url: '/:organisation/invoices', params: { organisation } }] as const

export type InvoiceIndexQueryKey = ReturnType<typeof invoiceIndexQueryKey>

/** @see backend/nexus/modules/Billing/Http/Controllers/InvoiceController.php InvoiceController::index */
export function invoiceIndexQueryOptions(
	organisation: InvoiceIndexPathParams['organisation'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		InvoiceIndexResponse,
		AxiosError<InvoiceIndexError>,
		InvoiceIndexResponse,
		InvoiceIndexQueryKey
	>({
		queryKey: invoiceIndexQueryKey(organisation),
		queryFn: ({ signal }) => invoiceIndex(organisation, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/InvoiceController.php InvoiceController::index */
export function useInvoiceIndex<TSelectData = InvoiceIndexResponse>(
	organisation: InvoiceIndexPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<InvoiceIndexResponse, AxiosError<InvoiceIndexError>, TSelectData, InvoiceIndexQueryKey>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<InvoiceIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...invoiceIndexQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/InvoiceController.php InvoiceController::index */
export function useInvoiceIndexSuspense<TSelectData = InvoiceIndexResponse>(
	organisation: InvoiceIndexPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					InvoiceIndexResponse,
					AxiosError<InvoiceIndexError>,
					TSelectData,
					InvoiceIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<InvoiceIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...invoiceIndexQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
